import {
  currencyFormat,
  dateDayjsFormat,
  dateFormat,
} from "../utils/formatter";
import useDateRangeCol from "./useDateRangeCol";

const usePayRateHistCols = () => {
  const beginDate = useDateRangeCol("BEG_DATE", "Begin Date");
  const dateStampDate = useDateRangeCol("DATE_STAMP", "Date");

  const payRateHistCols = [
    beginDate,
    {
      accessorKey: "PAY_RATE",
      header: "Pay Rate",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "ANNUAL_SALARY",
      header: "Salary",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    dateStampDate,
    {
      accessorKey: "SALARY_CLASS",
      header: "Salary Class",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "POS_LEVEL",
      header: "Position Level",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ANNUAL_HOURS",
      header: "Annual Hours",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "NBR_FTE",
      header: "NBR FTE",
      filterFn: "contains",
      size: 1,
    },
  ];

  return payRateHistCols;
};

const usePerActHistCols = () => {
  const effectDateCol = useDateRangeCol("EFFECT_DATE", "Effect Date");
  const dateStampCol = useDateRangeCol("DATE_STAMP", "Date stamp");

  const perActHistCols = [
    {
      accessorKey: "ACTION_CODE",
      header: "Action Code",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => {
        return <span>{cell.row.original.ACTION_CODE_LINK}</span>;
      },
    },
    effectDateCol,
    {
      accessorKey: "ACTION_NBR",
      header: "Action Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "REASON_01",
      header: "Reason",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "REASON_02",
      header: "Reason 2",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "USER_ID",
      header: "User ID",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ACTION_TYPE",
      header: "Action Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CREATE_USER",
      header: "Create User",
      filterFn: "contains",
      size: 1,
    },
    dateStampCol,
    {
      accessorKey: "COMMENT_LINK",
      header: "Comments",
      size: 1,
      meta: { excludeFromExport: true },
    },
  ];
  return perActHistCols;
};

const useReviewCols = () => {
  const reviewDateCol = useDateRangeCol("REVIEW_DATE", "Review Date");
  const scheduleDateCol = useDateRangeCol("SCHED_DATE", "Schedule Date");

  const reviewCols = [
    {
      accessorKey: "REVIEW_TYPE",
      header: "Review Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RATING",
      header: "Rating",
      filterFn: "contains",
      size: 1,
    },
    reviewDateCol,
    scheduleDateCol,
    {
      accessorKey: "REVIEWED_BY",
      header: "Reviewed By",
      filterFn: "contains",
      size: 1,
    },
  ];
  return reviewCols;
};

const useCertificatesCols = () => {
  const dateAcquiredCol = useDateRangeCol("DATE_ACQUIRED", "Date Acquired");
  const renewDateCol = useDateRangeCol("RENEW_DATE", "Renew Date");

  const certificatesCols = [
    {
      accessorKey: "TYPE",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CODE",
      header: "Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "LIC_NUMBER",
      header: "License Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "INSTRUCTOR",
      header: "Institution",
      filterFn: "contains",
      size: 1,
    },
    dateAcquiredCol,
    renewDateCol,
    {
      accessorKey: "IN_PRO_FLAG",
      header: "In Process",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "VERIFIED_FLAG",
      header: "Verify",
      filterFn: "contains",
      size: 1,
    },
  ];

  return certificatesCols;
};

const useDisciplinaryCols = () => {
  const dateActionCol = useDateRangeCol("DATE", "Action Date");
  const dateOutcomeCol = useDateRangeCol("OUTCOME_DATE", "Outcome Date");
  const dateReportCol = useDateRangeCol("REPORT_DATE", "Report Date");

  const disciplinaryCols = [
    {
      accessorKey: "TYPE",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "GRIEV_DIS_NBR",
      header: "Action",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DESCRIPTION",
      header: "Desc",
      filterFn: "contains",
      size: 1,
    },
    dateActionCol,
    {
      accessorKey: "CATEGORY",
      header: "Category",
      filterFn: "contains",
      size: 1,
    },
    dateReportCol,
    {
      accessorKey: "REPORT_BY_NAME",
      header: "Reported By",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "GRIEV_DIS_STAT",
      header: "Status",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "STATUS_DESC",
      header: "Status Desc",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DEPARTMENT",
      header: "Dept",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "JOB_CODE",
      header: "Job Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SUPERVISOR",
      header: "Supervisor",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "COMMENT",
      header: "Comment",
      filterFn: "contains",
      size: 1,
    },
    dateOutcomeCol,
    {
      accessorKey: "OUTCOME",
      header: "Outcome",
      filterFn: "contains",
      size: 1,
    },
  ];

  return disciplinaryCols;
};

const useDedCols = () => {
  const beginDateCol = useDateRangeCol("Begin_Date", "Begin date");
  const endDateCol = useDateRangeCol("End_Date", "End date");

  const dedCols = [
    {
      accessorKey: "Ded",
      header: "Ded",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Description",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Amount",
      header: "Amount or Percent",
      filterFn: "contains",
    },
    {
      accessorKey: "Type",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Balance",
      header: "Balance Amount",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "one",
      header: "1",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "two",
      header: "2",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "three",
      header: "3",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "four",
      header: "4",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "five",
      header: "5",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "six",
      header: "6",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "seven",
      header: "7",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "eight",
      header: "8",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "nine",
      header: "9",
      filterFn: "contains",
      size: 1,
    },
    beginDateCol,
    endDateCol,
    {
      accessorKey: "Pty",
      header: "Pty",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Ar",
      header: "Ar",
      filterFn: "contains",
      size: 1,
    },
  ];

  return dedCols;
};

const useCheckCols = () => {
  const checkDateCol = useDateRangeCol("CHECK_DATE", "Check date");
  const perEndDateCol = useDateRangeCol("PER_END_DATE", "Period end date");

  const checkCols = [
    {
      accessorKey: "CHECK_ID",
      header: "Check Id",
      filterFn: "contains",
      size: 1,
      meta: { excludeFromExport: true },
      Cell: ({ cell }) => {
        return <span>{cell.row.original.CHECK_VIEW}</span>
      },
    },
    {
      accessorKey: "CHECK_NBR",
      header: "Check Number",
      filterFn: "contains",
      size: 1,
    },
    checkDateCol,
    {
      accessorKey: "PRINT_TYPE",
      header: "Print Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CHECK_TYPE",
      header: "Check Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "STATUS",
      header: "Status",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "GROSS_PAY",
      header: "Gross Pay",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "NET_PAY_AMT",
      header: "Net Pay Amount",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    perEndDateCol,
    {
      accessorKey: "M_CHECK_TYPE",
      header: "M Check Type",
      filterFn: "contains",
      size: 1,
    },
  ];

  return checkCols;
};

const useHrHistCols = () => {
  const beginDateCol = useDateRangeCol("BEG_DATE", "Begin date");
  const dateStampCol = useDateRangeCol("DATE_STAMP", "Date");
  const effectDateCol = useDateRangeCol("EFFECT_DATE", "Effective date");

  const hrHistCols = [
    {
      accessorKey: "FLD_NBR",
      header: "Field Number",
      filterFn: "contains",
      size: 1,
    },
    beginDateCol,
    {
      accessorKey: "N_VALUE",
      header: "N Value",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "A_VALUE",
      header: "A Value",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "D_VALUE",
      header: "D Value",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "USER_ID",
      header: "User ID",
      filterFn: "contains",
      size: 1,
    },
    dateStampCol,
    {
      accessorKey: "ACTION_CODE",
      header: "Action Code",
      filterFn: "contains",
      size: 1,
    },
    effectDateCol,
    {
      accessorKey: "REASON_01",
      header: "Reason 1",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "REASON_02",
      header: "Reason 2",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "VIEW",
      header: "View",
      filterFn: "contains",
      size: 1,
    },
  ];
  return hrHistCols;
};

const useBenefitCols = () => {
  const startDateCol = useDateRangeCol("START_DATE", "Start date");
  const stopDateCol = useDateRangeCol("STOP_DATE", "Stop date");

  const benefitCols = [
    {
      accessorKey: "PLAN_TYPE",
      header: "Plan Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: 'PLAN_TYPE_DESC',
      header: 'Type Description',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'PLAN_CODE',
      header: 'Plan Code',
      filterFn: 'contains',
      size: 1,
    },
    {
      accessorKey: "DISPLAY_DESC",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "FLEX_PLAN",
      header: "Flex Plan",
      filterFn: "contains",
      size: 1,
    },
    startDateCol,
    stopDateCol,
    {
      accessorKey: "PLAN_OPTION",
      header: "Plan Option",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "COV_OPTION",
      header: "Cov Option",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "COVER_AMT",
      header: "Cover Amount",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "DEP_COVER_AMT",
      header: "Dep Cover Amount",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "ANNUAL_AMT",
      header: "Annual Amount",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
  ];

  return benefitCols;
};

const useDependentCols = () => {
  const birthDateCol = useDateRangeCol("birthdate", "Birth date");
  const deathDateCol = useDateRangeCol("death_date", "Death date");

  const dependentCols = [
    {
      accessorKey: "rel_code",
      header: "Relation Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "last_name",
      header: "Last Name",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "first_name",
      header: "First Name",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "fica_nbr",
      header: "Fica",
      filterFn: "contains",
      size: 1,
    },
    birthDateCol,
    {
      accessorKey: "sex",
      header: "Sex",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "dep_type",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "active_flag",
      header: "Active",
      filterFn: "contains",
      size: 1,
    },
    deathDateCol,
    {
      accessorKey: "VIEW",
      header: "Benefits",
      filterFn: "contains",
      size: 1,
    },
  ];

  return dependentCols;
};

const useTaxCols = () => {
  const taxCols = [
    {
      accessorKey: "DED_CODE",
      header: "Ded",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DESCRIPTION",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RES_CODE",
      header: "Res",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "MARITAL_STATUS",
      header: "Mar Status",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "EXEMPTIONS",
      header: "Exempt Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "EXEMPT_AMOUNT",
      header: "Exempt Amount",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "TAX_EXEMPT_FLG",
      header: "Tax Exm",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CERT_CODE",
      header: "Cert Code",
      filterFn: "contains",
      size: 1,
    },
  ];

  return taxCols;
};

const useEducationCols = () => {
  const educationCols = [
    {
      accessorKey: "CODE",
      header: "Degree",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SUBJECT",
      header: "Subject",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "INSTRUCTOR",
      header: "Institution",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RENEW_DATE",
      header: "Complete Date",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => dateFormat(cell.getValue()),
    },
    {
      accessorKey: "RATING",
      header: "Rating",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "IN_PRO_FLAG",
      header: "In Process",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "VERIFIED_FLAG",
      header: "Verify",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CO_SPONSORED",
      header: "Company Sponsor",
      filterFn: "contains",
      size: 1,
    },
  ];

  return educationCols;
};

const useCertCols = () => {
  const dateAquiredCol = useDateRangeCol("DATE_ACQUIRED", "Date Aquired");
  const renewDateCol = useDateRangeCol("RENEW_DATE", "Renewal Date");

  const certCols = [
    {
      accessorKey: "CODE",
      header: "Certification",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DESCRIPTION",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    dateAquiredCol,
    renewDateCol,
    {
      accessorKey: "STATE",
      header: "ST or Prov",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "LIC_NUMBER",
      header: "License Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RENEWAL_CYLCE",
      header: "Renewal Cycle",
      filterFn: "contains",
      size: 1,
    },
  ];

  return certCols;
};

const usePositionHistoryCols = () => {
  const effectDateCol = useDateRangeCol("EFFECT_DATE", "Effect Date");
  const endDateCol = useDateRangeCol("END_DATE", "End Date");

  const positionHistoryCols = [
    {
      accessorKey: "POSITION",
      header: "Position",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "POS_LEVEL",
      header: "Level",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DESCRIPTION",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "FTE",
      header: "FTE",
      filterFn: "contains",
      size: 1,
    },
    effectDateCol,
    endDateCol,
    {
      accessorKey: "JOB_CODE",
      header: "Job Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "PROCESS_LEVEL",
      header: "Process Level",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DEPARTMENT",
      header: "Department",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "PAY_RATE",
      header: "Pay Rate",
      filterFn: "contains",
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: "LOCAT_CODE",
      header: "Location Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SUPERVISOR",
      header: "Supervisor",
      filterFn: "contains",
      size: 1,
    },
  ];

  return positionHistoryCols;
};

const useCommentCols = () => {
  const dateCol = useDateRangeCol("DATE", "Date");

  const commentCols = [
    {
      accessorKey: "CMT_TYPE",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "TYPE_DESCRIPTION",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SEQ_NBR",
      header: "Seq Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "CMT_TEXT",
      header: "Text",
      filterFn: "contains",
      size: 1,
    },
    dateCol,
    {
      accessorKey: "PRINT_CODE",
      header: "Print Code",
      filterFn: "contains",
      size: 1,
    },
  ];
  return commentCols;
};

const useLp51Cols = () => {
  const requestDateCol = useDateRangeCol("REQUEST_DATE", "Request Date");
  const beginDateCol = useDateRangeCol("BEGIN_DATE", "Begin Date");
  const expectedBeginDateCol = useDateRangeCol(
    "EXPECTED_RETURN_DATE",
    "Expected Return Date"
  );
  const returnDateCol = useDateRangeCol("RETURN_DATE", "Return Date");
  const endDateCol = useDateRangeCol("END_DATE", "End Date");
  const serviceDateCol = useDateRangeCol("SERVICE_DATE", "Service Date");

  const lp51Cols = [
    {
      accessorKey: "COMPANY",
      header: "Company",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "EMPLOYEE",
      header: "Employee",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "LEAVE_NUMBER",
      header: "Leave Number",
      filterFn: "contains",
      size: 1,
    },
    requestDateCol,
    beginDateCol,
    expectedBeginDateCol,
    returnDateCol,
    endDateCol,
    {
      accessorKey: "LEAVE_REASON",
      header: "Leave Reason",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "INTERMITTENT",
      header: "Intermittent",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "REASON_CLASS",
      header: "Reason Class",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "STATUS",
      header: "Status",
      filterFn: "contains",
      size: 1,
    },
    serviceDateCol,
    {
      accessorKey: "MEMO",
      header: "Memo",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "PHYSICIAN_RELEASE",
      header: "Physician Release",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RESTRICTED_DUTY",
      header: "Restricted Duty",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "RESTRICTED_THRU",
      header: "Restricted Thru",
      filterFn: "contains",
      size: 1,
    },
  ];
  return lp51Cols;
};

const useLengthOfServiceCols = () => {
  const dateHiredCol = useDateRangeCol("DATE_HIRED", "Date Hired");
  const adjHireDateCol = useDateRangeCol("ADJ_HIRE_DATE", "Adj Hire Date");
  const anniversDateCol = useDateRangeCol("ANNIVERS_DATE", "Anniversary Date");
  const seniorDateCol = useDateRangeCol("SENIOR_DATE", "Senior Date");
  const serviceDateCol = useDateRangeCol("SERVICE_DATE", "Service Date");

  const lengthOfServiceCols = [
    {
      accessorKey: "COMPANY",
      header: "Company",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "EMPLOYEE",
      header: "Employee",
      filterFn: "contains",
      size: 1,
    },
    dateHiredCol,
    {
      accessorKey: "DATE_HIRED_DAYS",
      header: "Date Hired Days",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DATE_HIRED_YEARS",
      header: "Date Hired Years",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "DATE_HIRED_MONTHS",
      header: "Date Hired Months",
      filterFn: "contains",
      size: 1,
    },
    adjHireDateCol,
    {
      accessorKey: "ADJ_HIRE_DAYS",
      header: "Adj Hire Days",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ADJ_HIRE_YEARS",
      header: "Adj Hire Years",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ADJ_HIRE_MONTHS",
      header: "Adj Hire Months",
      filterFn: "contains",
      size: 1,
    },
    anniversDateCol,
    {
      accessorKey: "ANNIVERS_DAYS",
      header: "Anniversary Days",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ANNIVERS_YEARS",
      header: "Anniversary Years",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "ANNIVERS_MONTHS",
      header: "Anniversary Months",
      filterFn: "contains",
      size: 1,
    },
    seniorDateCol,
    {
      accessorKey: "SENIOR_DAYS",
      header: "Senior Days",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SENIOR_YEARS",
      header: "Senior Years",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "SENIOR_MONTHS",
      header: "Senior Months",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "POSITION",
      header: "Position",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "JOB_CODE",
      header: "Job Code",
      filterFn: "contains",
      size: 1,
    },
    serviceDateCol,
    {
      accessorKey: "DAYS_IN_POSITION",
      header: "Days in Position",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "YEARS_IN_POSITION",
      header: "Years in Position",
      filterFn: "contains",
      size: 1,
    },
  ];
  return lengthOfServiceCols;
};

const useGarnishmentCols = () => {
  const effectDateCol = useDateRangeCol("EFFECT_DATE", "Effect Date");
  const endDateCol = useDateRangeCol("END_DATE", "End Date");

  const garnishmentCols = [

    {
      accessorKey: 'COMPANY',
      header: 'Company',
      filterFn: 'contains'
    },
    {
      accessorKey: 'EMPLOYEE',
      header: 'Employee',
      filterFn: 'contains'
    },
    {
      accessorKey: 'CASE_NUMBER',
      header: 'Case Number',
      filterFn: 'contains'
    },
    {
      accessorKey: 'FILE_NUMBER',
      header: 'File Number',
      filterFn: 'contains'
    },
    {
      accessorKey: 'DESC',
      header: 'Desc',
      filterFn: 'contains'
    },
    {
      accessorKey: 'TAX_ID_CODE',
      header: 'Tax ID Code',
      filterFn: 'contains'
    },
    {
      accessorKey: 'TYPE',
      header: 'Type',
      filterFn: 'contains'
    },
    {
      accessorKey: 'DED_CODE',
      header: 'Ded Code',
      filterFn: 'contains'
    },
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description',
      filterFn: 'contains'
    },
    {
      accessorKey: 'NEXT_AMOUNT',
      header: 'Next Amount',
      filterFn: 'contains'
    },
    {
      accessorKey: 'AMOUNT_2',
      header: 'Amount 2',
      filterFn: 'contains'
    },
    {
      accessorKey: 'ORIG_BALANCE',
      header: 'Orig Balance',
      filterFn: 'contains'
    },
    {
      accessorKey: 'BALANCE_AMT',
      header: 'Balance Amt',
      filterFn: 'contains'
    },
    {
      accessorKey: 'MONTHLY_LIMIT',
      header: 'Monthly Limit',
      filterFn: 'contains'
    },
    {
      accessorKey: 'EXCLUDE_AMT',
      header: 'Exclude Amt',
      filterFn: 'contains'
    },
    {
      accessorKey: 'BALANCE_TYPE',
      header: 'Balance Type',
      filterFn: 'contains'
    },
    {
      accessorKey: 'VENDOR',
      header: 'Vendor',
      filterFn: 'contains'
    },
    {
      accessorKey: 'DED_PRIORITY',
      header: 'Ded Priority',
      filterFn: 'contains'
    },
    effectDateCol,
    endDateCol
  ]
  return garnishmentCols;
};

const useRateCols = () => {
  const effectDateCol = useDateRangeCol("EFFECT_DATE", "Effect Date");
  const endDateCol = useDateRangeCol("END_DATE", "End Date");
  
  const rateCols = [
    {
      accessorKey: 'PAY_RATE',
      header: 'Pay Rate',
      filterFn: 'contains'
    },
    {
      accessorKey: 'CURRENCY_CODE',
      header: 'Currency Code',
      filterFn: 'contains'
    },
    {
      accessorKey: 'PROCESS_LEVEL',
      header: 'Process Level',
      filterFn: 'contains'
    },
    {
      accessorKey: 'DEPARTMENT',
      header: 'Department',
      filterFn: 'contains'
    },
    {
      accessorKey: 'POSITION',
      header: 'Position',
      filterFn: 'contains'
    },
    {
      accessorKey: 'JOB_CODE',
      header: 'Job Code',
      filterFn: 'contains'
    },
    {
      accessorKey: 'PAY_CODE',
      header: 'Pay Code',
      filterFn: 'contains'
    },
    effectDateCol,
    endDateCol
  ]
  return rateCols
}

const useCompetenciesCols = () => {
  const dateAcquiredCol = useDateRangeCol("DATEACQUIRED", "Date Acquired");
  const lastUsedCol = useDateRangeCol("LASTUSED", "Last Used");

  const competenciesCols = [
    {
      accessorKey: "Type",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Competency",
      header: "Competency",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Description",
      header: "Description",
      filterFn: "contains",
      size: 1,
    },
    dateAcquiredCol,
    lastUsedCol,
    {
      accessorKey: "Rating",
      header: "Rating",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Proficiency",
      header: "Proficiency",
      filterFn: "contains",
      size: 1,
    },
  ];

  return competenciesCols;
};

const useBeneficiariesCols = () => {
  const beneficiariesCols = [
    {
      accessorKey: "Benefit Type",
      header: "Benefit Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Plan",
      header: "Plan",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Type",
      header: "Type",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Primary or Contingent",
      header: "Primary or Contingent",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Percent / Amount",
      header: "Percent / Amount",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Amount",
      header: "Amount",
      filterFn: "contains",
      size: 1
    },
    {
      accessorKey: "Prefix",
      header: "Prefix",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Last Name",
      header: "Last Name",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Suffix",
      header: "Suffix",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "First Name",
      header: "First Name",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Middle Initial",
      header: "Middle Initial",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Relationship",
      header: "Relationship",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Social Number",
      header: "Social Number",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Trust",
      header: "Trust",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Comments",
      header: "Comments",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Employee Address",
      header: "Employee Address",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Address 1",
      header: "Address 1",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Address 2",
      header: "Address 2",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Address 3",
      header: "Address 3",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Address 4",
      header: "Address 4",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "City or Address 5",
      header: "City or Address 5",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "State or Province",
      header: "State or Province",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Postal Code",
      header: "Postal Code",
      filterFn: "contains",
      size: 1,
    },
    {
      accessorKey: "Country",
      header: "Country",
      filterFn: "contains",
      size: 1,
    },
  ];

  return beneficiariesCols;
};

export {
  usePayRateHistCols,
  usePerActHistCols,
  useReviewCols,
  useCertificatesCols,
  useDedCols,
  useCheckCols,
  useHrHistCols,
  useBenefitCols,
  useBeneficiariesCols,
  useDependentCols,
  useDisciplinaryCols,
  useTaxCols,
  useEducationCols,
  useCertCols,
  usePositionHistoryCols,
  useCommentCols,
  useLp51Cols,
  useLengthOfServiceCols,
  useGarnishmentCols,
  useRateCols,
  useCompetenciesCols
};
